import React, { useState, useEffect } from 'react';
import { Fab } from '@material-ui/core';
import { KeyboardArrowUp } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'fixed',
        bottom: theme.spacing(6),
        right: theme.spacing(3),
        zIndex: 1000,
        opacity: 0.8,
        width: 45,
        height: 45,
    },
}));

const ScrollToTopButton = () => {
    const classes = useStyles();
    const [visible, setVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <div className={classes.root}>
            {visible && (
                <Fab
                    color="default"
                    onClick={scrollToTop}
                    aria-label="scroll back to top"
                >
                    <KeyboardArrowUp />
                </Fab>
            )}
        </div>
    );
};

export default ScrollToTopButton;